import { Injectable } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { BehaviorSubject } from "rxjs";
@Injectable({
  providedIn: 'root' 
})
export class DialogCloseService {
    private registerDialogEvent = new BehaviorSubject<MatDialogRef<any, any>>(null);

    emitRegisterDialog(dialogRef: MatDialogRef<any, any>) {
        this.registerDialogEvent.next(dialogRef)
    }

    registerEventListner() {
        return this.registerDialogEvent.asObservable();
    }

}